import { MusicNote, SealCheck } from '@phosphor-icons/react';

//
// Тип верификации (type):
// 1 - подтвержденный профиль
// 2 - артист (музыка)
//

export default function VerifiedBadge({ size = 14, type = 1 }) {
    const isArtist = Number(type) === 2;
    const Icon = isArtist ? MusicNote : SealCheck;

    return (
        <Icon
            weight="fill"
            // Нота визуально крупнее печати при равном размере — уравниваем.
            size={isArtist ? size - 2 : size}
            color="var(--joy-palette-primary-500)"
            style={{ flexShrink: 0, display: 'block' }}
        />
    );
}

/**
 * Подпись под именем: чем именно подтверждён аккаунт.
 *
 * @param {number} type - тот же `verified`, что и у значка
 * @returns {string|null} null, если тип неизвестен — тогда подпись не рисуем
 */
export function verifiedBadgeText(type = 1) {
    switch (Number(type)) {
        case 1:
            return 'Официальный аккаунт';
        case 2:
            return 'Подтвержденный исполнитель';
        default:
            return null;
    }
}
